import { AbstractControl, FormControl, FormGroup } from '@angular/forms'
import { InsuranceProviderConfiguration } from '@mmx/shared'

export function removeIrrelevantControls(formGroup: FormGroup, elements?: InsuranceProviderConfiguration.Elements) {
  for (const key in formGroup.controls) {
    const element = elements?.[key]
    if (!element || element.type === InsuranceProviderConfiguration.ElementType.UNSUPPORTED) {
      formGroup.removeControl(key)
      continue
    }

    const control = formGroup.controls[key]

    if (control instanceof FormGroup) {
      removeIrrelevantControls(control, element.elements)
    }
  }
}

export function getDependantControl(controlName: string, control: AbstractControl): AbstractControl | undefined {
  let parent = control.parent
  while (!!parent) {
    if (parent.controls[controlName]) {
      return parent.controls[controlName]
    }

    parent = parent.parent
  }
}

/**
 *
 * @param whenCondition
 *
 * Returns list of comparator functions.
 * Each function accepts value to compare, makes comparison and returns back
 * condition if it was met
 *
 */
export function getConditionComparators(
  whenCondition: InsuranceProviderConfiguration.ElementWhenCondition[] | InsuranceProviderConfiguration.ElementWhenCondition): Function[] {
  const comparators: Function[] = []
  let conditions: InsuranceProviderConfiguration.ElementWhenCondition[] = Array.isArray(whenCondition) ? whenCondition : [whenCondition]

  for (const condition of conditions) {
    if (condition.containedIn) {
      comparators.push((value: any) => {
        const index = condition.containedIn.findIndex((v) => v === value)
        if (index !== -1) {
          return condition
        }
      })
    }

    if (condition.greaterThan) {
      comparators.push((value: any) => {
        if (value > condition.greaterThan) {
          return condition
        }
      })
    }

    if (condition.lessThan) {
      comparators.push((value: any) => {
        if (value < condition.lessThan) {
          return condition
        }
      })
    }

    if (condition.greaterEqual) {
      comparators.push((value: any) => {
        if (value >= condition.greaterEqual) {
          return condition
        }
      })
    }

    if (condition.lessEqual) {
      comparators.push((value: any) => {
        if (value <= condition.lessEqual) {
          return condition
        }
      })
    }

    if (condition.maxLength) {
      comparators.push((value: any) => {
        if (value.length <= condition.maxLength) {
          return condition
        }
      })
    }

    if (condition.pattern) {
      // tbd
    }

    if (condition.equalTo) {
      comparators.push((value: any) => {
        if (value === condition.equalTo) {
          return condition
        }
      })
    }
  }

  return comparators
}

export function getNameControls() {
  return {
    lastName: new FormControl(),
    firstName: new FormControl(),
    middleName: new FormControl(),
    suffix: new FormControl(),
  }
}

export function getLocationControls(): Record<string, FormControl> {
  return {
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    city: new FormControl(),
    state: new FormControl(),
    stateCode: new FormControl(),
    zipCode: new FormControl(),
  }
}
